'use es6';

import { useEffect, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withToolbarSpace(WrappedComponent) {
  return function WithToolbarSpace(props) {
    const {
      editor,
      hasFocus,
      inlineToolbarContainer
    } = props;
    const lastPaddingTop = useRef(0);
    const rafReq = useRef(null);
    useEffect(() => {
      editor.getDoc().body.style.setProperty('transition', 'padding-top .33s ease', 'important');
    }, [editor]);
    useEffect(() => {
      function adjustTopPadding() {
        const toolbarHeight = inlineToolbarContainer.clientHeight;
        const window = editor.getWin();
        const body = editor.getDoc().body;
        const scrollTop = window.pageYOffset;
        const topDelta = toolbarHeight - scrollTop;
        let paddingTop = 0;
        if (topDelta > 0 && hasFocus) {
          paddingTop = topDelta;
        } else {
          paddingTop = 0;
        }
        if (paddingTop === lastPaddingTop.current) {
          return;
        }
        rafReq.current = requestAnimationFrame(() => {
          lastPaddingTop.current = paddingTop;
          body.style.setProperty('padding-top', `${paddingTop}px`, 'important');
        });
      }
      adjustTopPadding();
      window.addEventListener('scroll', adjustTopPadding);
      return () => {
        window.removeEventListener('scroll', adjustTopPadding);
        if (rafReq.current) {
          cancelAnimationFrame(rafReq.current);
        }
      };
    }, [hasFocus, editor, inlineToolbarContainer]);
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props));
  };
}